<template>
    <div v-if="ENV.enviroment !== 'production'">
        <span> Development version: {{ version }} </span>
        <br>
        <span> Touchscreen device: {{ isTouchScreen ? "Yes" : "No" }} </span>
    </div>
</template>

<script>
import eventbus from "@eventbus";
import isTouchScreen from "@helpers/touchscreen";

export default {
    name: "Version",
    data() {
        return {
            isTouchScreen: null,
            version: "",
        };
    },
    mounted() {
        this.isTouchScreen = isTouchScreen;
        eventbus.on("set-version", this.setVersion);
    },
    unmounted() {
        eventbus.off("set-version", this.setVersion);
    },
    methods: {
        setVersion(version) {
            this.version = version;
        },
    },
};
</script>
